import { render, staticRenderFns } from "./EditPaymodel.vue?vue&type=template&id=544b0272&scoped=true&"
import script from "./EditPaymodel.vue?vue&type=script&lang=js&"
export * from "./EditPaymodel.vue?vue&type=script&lang=js&"
import style0 from "./EditPaymodel.vue?vue&type=style&index=0&id=544b0272&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544b0272",
  null
  
)

export default component.exports